import { SingleSelectField } from "@dgs/core";
import { FC } from "react";
import { useTranslation } from "react-i18next";

interface Props {
	label: string;
	name: string;
}

export type Weekday = "monday" | "tuesday" | "wednesday" | "thursday" | "friday" | "saturday" | "sunday";

const options: Weekday[] = ["monday", "tuesday", "wednesday", "thursday", "friday", "saturday", "sunday"];

export const WeekdaySelectField: FC<Props> = ({ label, name }) => {
	const { t } = useTranslation();

	return (
		<SingleSelectField
			label={label}
			name={name}
			getLabel={(option) => t(option)}
			clearable={false}
			required={true}
			options={options}
		/>
	);
};
